module.exports = __webpack_public_path__ + "static/originPin-1810bd5d67c9819e64a6f7e748d65a0b.png";